import createReducer from 'utils/createReducer';

const SET_OPENED = 'journey-handling/SET_OPENED';
const SET_CLOSED = 'journey-handling/SET_CLOSED';
const SET_SELECTED_AGENT = 'journey-handling/SET_SELECTED_AGENT';
const SET_LOADING = 'journey-handling/SET_LOADING';

// Initial State
const INIT_STATE = {
  opened: false,
  openedId: null,
  handledBy: null,
  selectedAgent: null,
  loading: false,
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_OPENED](state, { id, handledBy }) {
    return {
      ...state,
      opened: true,
      openedId: id,
      handledBy: handledBy,
      selectedAgent: null,
      loading: false,
    };
  },
  [SET_CLOSED](state) {
    return {
      ...state,
      opened: false,
      openedId: null,
      handledBy: null,
      selectedAgent: null,
      loading: false,
    };
  },
  [SET_SELECTED_AGENT](state, { agent }) {
    return {
      ...state,
      selectedAgent: agent,
    };
  },
  [SET_LOADING](state, loading) {
    return {
      ...state,
      loading,
    };
  },
});

export const setOpened = (opened) => ({
  type: SET_OPENED,
  payload: opened,
});

export const setClosed = () => ({
  type: SET_CLOSED,
  payload: null,
});

export const setSelectedAgent = ({ agent }) => ({
  type: SET_SELECTED_AGENT,
  payload: {
    agent,
  },
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});
